import { useGraphqlApiHeaders } from 'business/contextProviders/useApiHeaders';
import { Module_Enum, useGetImportConfigQuery } from 'generated/graphql';

interface ColumnDefinition {
  label: string;
  definition: string;
}

export const useImportConfData = (projectId: string) => {
  const columns: ColumnDefinition[] = [];
  const extraColumns: ColumnDefinition[] = [];

  const graphqlHeaders = useGraphqlApiHeaders(Module_Enum.QualityScan);
  const { data } = useGetImportConfigQuery({
    variables: {
      projectId,
    },
    context: { headers: graphqlHeaders },
  });

  if (data && data.mainColumns.length > 0) {
    columns.push(
      {
        label: data.mainColumns[0].serialNumberColumn,
        definition: 'qualityControl.segmentImport.details.serialNumber',
      },
      {
        label: data.mainColumns[0].segmentTypeColumn,
        definition: 'qualityControl.segmentImport.details.segmentType',
      },
      {
        label: data.mainColumns[0].moldColumn,
        definition: 'qualityControl.segmentImport.details.mold',
      },
      {
        label: data.mainColumns[0].manufactureDateColumn,
        definition: 'qualityControl.segmentImport.details.manufactureDate',
      },
    );
  }

  if (data) {
    data.extraColumns.forEach((column) => {
      extraColumns.push({
        label: column.columnHeader,
        definition: column.segmentParameter,
      });
    });
  }

  return {
    columns,
    extraColumns,
  };
};
